import { setGlobalLoading } from "../state/usePlannerStore"; // Import setGlobalLoading

export class ApiError extends Error {
  constructor(public status: number, public body: unknown) {
    super(`API ${status}`);
  }
}

async function handle<T>(res: Response): Promise<T> {
  if (res.status === 401) {
    const next = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.assign(`/login?next=${next}`);
    throw new ApiError(401, null);
  }
  const text = await res.text();
  const body = text ? (JSON.parse(text) as unknown) : null;
  if (!res.ok) throw new ApiError(res.status, body);
  return body as T;
}

async function apiCall<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  setGlobalLoading(true); // Show loader
  try {
    const res = await fetch(path, { credentials: "include", ...options });
    return await handle<T>(res);
  } finally {
    setGlobalLoading(false); // Hide loader
  }
}

export async function apiGet<T>(path: string): Promise<T> {
  return apiCall<T>(path);
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  return apiCall<T>(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function apiPatch<T>(path: string, body: unknown): Promise<T> {
  return apiCall<T>(path, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function apiPut<T>(path: string, body: unknown): Promise<T> {
  return apiCall<T>(path, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function apiDelete<T>(path: string): Promise<T> {
  return apiCall<T>(path, { method: "DELETE" });
}
